module.exports = __webpack_public_path__ + "media/cases/hero-629d505f.png";